import { Show } from "solid-js";
import { Icon } from "@iconify-icon/solid";

import {
  TableCell,
  TableRow,
} from "@/components/shadcn/table";
import { ListItemCheckbox } from "./ListItemCheckbox";

export const ListRow = (props) => {

  return (
    <TableRow class="border-top border-slate-100 py-1 px-1">
      <Show when={props.move || props.action}>
        <TableCell width="1%" class="ps-2">
          <div class="text-nowrap" style="height: 100%;">
            <Show when={props.action}>
              <ListItemCheckbox key={props.key} items={props.items} onToggle={props.onToggle} />
            </Show>
            <Show when={props.move}>
              <Icon icon="arrows" />
            </Show>
          </div>
        </TableCell>
      </Show>
      {props.children}
    </TableRow>
  );
}
